import React from 'react';
import { Grid, Box, useTheme } from '@mui/material';
import { IQuestionTemplate } from '@righton/networking';
import { ScreenSize, CardType, UserStatusType } from '../../lib/CentralModels';
import DetailedQuestionCardBase from '../cards/detailedquestion/DetailedQuestionCardBase';
import DetailedQuestionSubCard from '../cards/detailedquestion/DetailedQuestionSubCard';
import OwnerTag from '../profile/OwnerTag';
import {
  DetailedQuestionContainer,
  CardContainer,
  SubCardGridItem,
} from '../../lib/styledcomponents/QuestionTabsStyledComponents';
import LoginModal from '../modal/LoginModal';

interface ViewQuestionsProps {
  screenSize: ScreenSize;
  question: IQuestionTemplate;
  isViewGame: boolean;
  userStatus: UserStatusType;
  isCreateGame?: boolean;
}

export default function ViewQuestionCards({
  screenSize,
  question,
  isViewGame,
  userStatus,
  isCreateGame,
}: ViewQuestionsProps) {
  const theme = useTheme();

  return (
    <CardContainer sx={{ overflowY: 'visible' }}>
      {!isCreateGame && screenSize !== ScreenSize.LARGE && (
        <OwnerTag isViewGame={isViewGame} screenSize={screenSize} />
      )}
      <DetailedQuestionContainer
        sx={{
          overflowY: 'visible',
          gap:
            isCreateGame && screenSize === ScreenSize.SMALL
              ? 0
              : `${theme.sizing.mdPadding}px`,
        }}
        container
      >
        <Grid
          sm
          md
          item
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          {!isCreateGame && screenSize === ScreenSize.LARGE && (
            <OwnerTag isViewGame={isViewGame} screenSize={screenSize} />
          )}
        </Grid>
        <Grid
          sm={12}
          item
          style={{
            width: '100%',
            maxWidth: '672px',
            display: 'flex',
            flexDirection: 'column',
            gap: `${theme.sizing.smPadding}px`,
          }}
        >
          <DetailedQuestionCardBase
            isCreateGame={isCreateGame}
            dropShadow
            screenSize={screenSize}
            question={question}
          />
          <Box style={{position: 'relative'}}>
            {userStatus !== UserStatusType.LOGGEDIN &&
              <Box style={{width: '100%', display: 'flex', justifyContent: 'center', position: 'absolute', top: '48px', zIndex: 5}}>
                <LoginModal />
              </Box>
            }
            <Grid 
              container 
              spacing={`${theme.sizing.smPadding}px`} 
              style={{
                ...(userStatus !== UserStatusType.LOGGEDIN && {filter: 'blur(8px)'})
              }}
            >
                <SubCardGridItem item sm={12} md={6}>
                  <DetailedQuestionSubCard
                    cardType={CardType.CORRECT}
                    answer={
                      question?.choices?.find((answer) => answer.isAnswer)?.text ??
                      ''
                    }
                    instructions={question?.instructions ?? []}
                  />
                </SubCardGridItem>
                <SubCardGridItem item sm={12} md={6}>
                  {question &&
                    question.choices
                      ?.filter((choice) => !choice.isAnswer)
                      .map((choice, index) => (
                        <DetailedQuestionSubCard
                          key={choice.text}
                          cardType={CardType.INCORRECT}
                          answer={choice.text}
                          answerReason={choice.reason}
                        />
                      ))}
                </SubCardGridItem>
            </Grid>
          </Box>
        </Grid>
        <Grid sm md item />
      </DetailedQuestionContainer>
    </CardContainer>
  );
}
